import { UseQueryOptions } from '@tanstack/react-query';
import { DirectMailSenderProfile } from 'domains/content/types';
import { CuredApiPaths } from 'models/enums';
import useQuery from '../useQuery';
import QueryKeys from './keys';

const useDirectMailSenderProfile = ({
    senderProfileId,
    reactQueryOptions,
}: {
    senderProfileId: number;
    reactQueryOptions?: UseQueryOptions<DirectMailSenderProfile, Error>;
}) =>
    useQuery<DirectMailSenderProfile>(
        QueryKeys.DIRECT_MAIL_SENDER_PROFILE_ID(senderProfileId),
        `${CuredApiPaths.SENDER_PROFILES}/direct-mail/${senderProfileId}`,
        reactQueryOptions
    );

export default useDirectMailSenderProfile;
